import * as formik from 'formik';
import moment from 'moment';
import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import { IWindowComponentProps } from '../../../../../components/windows/WindowContext';
import { identificationButtonLocationEnum, servicesDisplayPositionType } from '../../../../../enums';
import * as models from '../../../../../models';

interface ITerminalCreateModalProps {
    refetchTerminals(): Promise<void>;
}

const validationSchema = Yup.object<models.ITerminal>().shape({
    name: Yup.string().required('Šis laukas yra privalomas'),
    model: Yup.string().required('Šis laukas yra privalomas')
});

const initialState: models.ITerminalListItem = {
    id: 0,
    name: '',
    model: '',
    locationId: 0,
    key: null,
    startWorkingHours: moment(),
    endWorkingHours: moment(),
    servicesDisplayPositionType: servicesDisplayPositionType.Middle,
    isServicesDescriptionButtonsShown: false,
    ticketTemplateId: 0,
    isPersonIdentificationButtonShown: false,
    isArrivalConfirmationButtonShown: false,
    isRepresentedUsersShown: false,
    isPrinterStatusReportable: false,
    identificationButtonLocation: identificationButtonLocationEnum.Top,
    isVisitSelectionEnabled: false,
    isSupportingFriendlyOrganizations: false,
    identificationButtonText_LT: null,
    identificationButtonText_EN: null,
    identificationButtonText_RU: null,
    isVirtual: true,
    isVisitButtonShown: true,
    connectionStatus: false,
    locationName: ''
};

const TerminalCreateModalWindow: FC<IWindowComponentProps<ITerminalCreateModalProps>> = (props) => {
    const {
        componentProps: { refetchTerminals },
        onClose
    } = props;

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: models.ITerminalListItem, formikActions: formik.FormikHelpers<models.ITerminalListItem>) => {
        try {
            setIsLoading(true);
            formikActions.setStatus();
            await api.administration.createTerminal(values);
            toast.success('Terminalas sėkmingai sukurtas');
            await refetchTerminals();
            onClose();
        } catch (ex) {
            toast.error(ex.error[0]);
            formikActions.setStatus(ex);
        } finally {
            formikActions.setSubmitting(false);
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <>
                    <formik.Formik
                        validationSchema={validationSchema}
                        initialValues={initialState}
                        onSubmit={handleSubmit}
                        render={(props) => (
                            <formik.Form>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                        <formik.Field
                                            name="name"
                                            render={({ field, form }: formik.FieldProps<string>) => (
                                                <fabric.TextField
                                                    {...field}
                                                    label="Pavadinimas"
                                                    placeholder="Įrašykite terminalo pavadinimą"
                                                    errorMessage={(props.status && props.status.name) || (form.errors.name && form.errors.name)}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                        <formik.Field
                                            name="model"
                                            render={({ field, form }: formik.FieldProps<string>) => (
                                                <fabric.TextField
                                                    {...field}
                                                    label="Modelis"
                                                    placeholder="Įrašykite terminalo modelį"
                                                    errorMessage={(props.status && props.status.model) || (form.errors.model && form.errors.model)}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={props.isSubmitting || !props.isValid || !props.dirty}
                                        type="submit"
                                    />
                                </div>
                            </formik.Form>
                        )}
                    />
                </>
            )}
        </>
    );
};

export default TerminalCreateModalWindow;
